import { render, staticRenderFns } from "./SetupHeader.vue?vue&type=template&id=52bc59d2&scoped=true"
import script from "./SetupHeader.vue?vue&type=script&lang=js"
export * from "./SetupHeader.vue?vue&type=script&lang=js"
import style0 from "./SetupHeader.vue?vue&type=style&index=0&id=52bc59d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bc59d2",
  null
  
)

export default component.exports